Application.Signature.Icon = {
    ui: {
        container: '.js-signature-icon.step-icon',
        preview: '.step-preview__preview-icon-container',
        input: '.step-preview__svg-input'
    },
    previewList: null,
    svgIcon: null,
    current: null,
    ready: function (previewList) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // bind handlers
        this.bind();

        // create icon
        this.svgIcon = new Application.SvgIcon();
        $(this.ui.preview).empty().append(this.svgIcon.element);

    },
    bind: function(){

        var self = this;

        this.previewList.setOnChange(function(id, src, data){
            self.icon(id, src, data.previewWidthRatio, data.x, data.isPng || data.isGif);
        });
        this.previewList.setOnReset(function(){
            self.icon(self.current.id, self.current.src, self.current.ratio, self.current.x, self.current.isPng);
        });

    },
    icon: function(id, src, ratio, x, isPng){

        var self = this;

        // save
        this.current = {id: id, src: src, ratio: ratio, x: x, isPng: isPng};

        // change size
        $(this.ui.preview).css('width', (ratio * $(this.ui.preview).data('width')) + 'em');
        // set x position
        $(this.ui.preview).css('margin-left', (x * $(this.ui.preview).data('width')) + 'em');

        // change icon
        if (isPng){
            this.svgIcon.setPng(src, Application.SvgIcon.FIT_WIDTH, function(){
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                // update input
                self.updateInput();
            });
        }else{
            this.svgIcon.setIcon(src, '#333', Application.SvgIcon.FIT_WIDTH, function(){
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                // update input
                self.updateInput();
            });
        }

    },
    updateInput: function(){

        $(this.ui.input).val(this.svgIcon.getSvg());

    }
};